<template>
    <div v-if="isShow" :class="['customer-service', visible ? 'active' : '']">
        <div class="hd" @click="visible = !visible">
            <span class="m-icon icon-sm-talk"></span>
            <p>官方客服</p>
            <span class="m-icon icon-more"></span>
        </div>
        <div class="bd">
            <img src="@/assets/img/customerService/wechatNew.png" />
            <p>官方微信</p>
            <p>扫一扫联系我们</p>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            visible: false,
            isShow: false
        }
    },
    watch: {
        $route () {
            const {customerService} = this.$route.query;
            if(!customerService) this.isShow = true
        }
    }
}
</script>
<style lang="scss" scoped>
.customer-service {
    position: fixed;
    bottom: 0px;
    right: 0px;
    width: 260px;
    z-index: 99;
    background-color: #fff;
    .m-icon {
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        display: inline-block;
    }
    .hd {
        height: 50px;
        background: #24211E;
        color: #fff;
        display: flex;
        align-items: center;
        padding: 0 20px;
        cursor: pointer;
        .icon-sm-talk {
            background-image: url('~@/assets/img/customerService/sm-talk.png');
            width: 14px;
            height: 15px;
            margin-right: 8px;
        }
        .icon-more {
            background-image: url('~@/assets/img/customerService/more.png');
            width: 12px;
            height: 7px;
            transform:rotate(180deg);
            transition: all 0.3s ease;
        }
        p {
            flex: 1;
        }
    }
    .bd {
        text-align: center;
        height: 0px;
        transition: all 0.3s ease;
        img {
            width: 160px;
            height: 160px;
            margin-bottom: 15px;
            margin: 30px 50px 0;
        }
        p {
            font-weight: 400;
            color: #000000;
            line-height: 14px;
            margin-bottom: 10px;
            &:last-child {
                padding-bottom: 30px;
            }
        }
    }
    &.active {
        .hd .icon-more {
            transform:rotate(0deg);
        }
        .bd {
            height: 260px;
        }
    }
}
</style>